import { theme as defaultTheme, extendTheme } from '@chakra-ui/react';

import { colors } from './colors';
import {
  Button,
  Checkbox,
  CollapsibleBox,
  Input,
  Kbd,
  Link,
  NumberInput,
  Slider,
  Tabs,
  Tag,
  Textarea,
  Tooltip,
} from './components';
import { shadows } from './shadows';
import { zIndices } from './z-index';

const styles = {
  global: () => ({
    // remove the default chakra body background color
    body: {
      bg: '',
    },
    // See https://github.com/chakra-ui/chakra-ui/blob/cc0598ddcb2a4e7f84859099556c228c5ff354fe/packages/components/css-reset/src/css-reset.tsx#L3
    '@supports (height: 100dvh)': {
      ':root': {
        '--chakra-vh': '100dvh',
      },
    },
  }),
};

export const theme = extendTheme({
  config: {
    cssVarPrefix: 'vg',
  },
  colors,
  zIndices,
  shadows,
  breakpoints: {
    ...defaultTheme.breakpoints,
    '3xl': '120em',
  },
  components: {
    Tabs,
    Textarea,
    Checkbox,
    Link,
    Kbd,
    Button,
    CollapsibleBox,
    Tag,
    Tooltip,
    Slider,
    Input,
    NumberInput,
  },
  fonts: {
    heading: `'Inter'`,
    body: `'Inter'`,
  },
  styles,
});
